import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        downloadPlanilha(){            
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/DownloadPlanilhaModelo',
                responseType: 'arraybuffer',
                headers: headers
            });
        },
        carregarPlanilha(planilhaCredenciais, idUsuario, idPerfilPortal, termoAceite){
           
            const formData = new FormData();
            formData.append('planilhaCredenciais', planilhaCredenciais);
            formData.append('idUsuario', idUsuario);
            formData.append('idPerfilPortal', idPerfilPortal);
            formData.append('termoAceite', termoAceite);

            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/ImportarPlanilha',
                responseType: 'json',
                headers: {'Content-Type':'multipart/form-data'},
                data: formData
            });
        },
        listarCredenciais(filters) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/ListarCredenciais',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        inserirCredencial(credencial, idFonte, idPerfil,idProduto) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/InserirCredencial',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'credencial':credencial, 'idFonte': idFonte, 'idPerfil': idPerfil,'idProduto': idProduto}),
            });
        },
        atualizarCredencial(credencial, idUserAlteracao, idFonte, idProduto) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/EditarCredencial',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'credencial': credencial, 'idUserAlteracao': idUserAlteracao, 'idFonte': idFonte,'idProduto': idProduto}),
            })
        },
        getCredencialFonte(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/RecuperarFontes',
                responseType: 'json',
                headers: headers,
            });
        }, 
        getProdutos(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/RecuperarProdutos',
                responseType: 'json',
                headers: headers,
            });
        },
        BuscarCredProdutoColumn(idCredencial) {
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/BuscarCredProdutoColumn',
                responseType: 'json',
                headers: headers,
                params: { 'idCredencial': idCredencial },
            });
        },
        getCredencialProduto(idCredencial){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/BuscarCredProduto',
                responseType: 'json',
                headers: headers,
                params: { 'idCredencial': idCredencial },
            });
        },
        getCredenciais(filter) {
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/CarregarFontesCredenciais',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        getPrioridadeJusBr(filter){
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/CarregarPrioridadeJusBr',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filter),
            });
        },
        inserirControlePrioridadeJusBr(prioridadeJusBr, idProduto) {
            debugger
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/InserirControlePrioridadeJusBr',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'prioridadeJusBr':prioridadeJusBr, 'idProduto': idProduto}),
            });
        },
        atualizarControlePrioridadeJusBr(prioridadeJusBr,idProduto ) {
            debugger
            return instance({
                method: 'post',
                baseURL,
                url: 'Credencial/AtualizarControlePrioridadeJusBr',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'prioridadeJusBr':prioridadeJusBr, 'idProduto': idProduto}),
            })
        },
        getFonteJusBr(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/RecuperarFontesJusBr',
                responseType: 'json',
                headers: headers,
            });
        }, 
        getCredenciaisFonteJusBr(nomeDivisao) {
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/CarregarCredenciaisFonteJusBr',
                responseType: 'json',
                headers: headers,
                params: { 'nomeDivisao': nomeDivisao },
            });
        },
        getCredencialProdutoJusBr(idCredencial, idPrioridade){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/BuscarCredProdutoJusBr',
                responseType: 'json',
                headers: headers,
                params: { 'idCredencial': idCredencial , 'idPrioridade': idPrioridade},
            });
        },
        getCodigoPoderTribunal(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Credencial/BuscarCodigoPoderTribunal',
                responseType: 'json',
                headers: headers,
            });
        }, 
        removerPrioridadeJusBr(prioridade) {
            return instance({
                method: 'post',
                baseURL,
                url: `Credencial/RemoverPrioridadeJusBr`,
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(prioridade),

            });
        }
    }
    return apiCalls;
}